module.exports = __webpack_public_path__ + "img/9.32b801b7.gif";